import React, { useState } from 'react';
import '../styles/styles.css'; // Asegúrate de que la ruta al CSS sea correcta
import '../styles/nav.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { patchPassword } from '../services/api';

const ChangePassword = () => {
  const [contrasenaActual, setContrasenaActual] = useState('');
  const [nuevaContrasena, setNuevaContrasena] = useState('');
  const [repetirContrasena, setRepetirContrasena] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (nuevaContrasena !== repetirContrasena) {
      toast.error('Las nuevas contraseñas no coinciden.');
      return;
    }

    const payload = {
      password: nuevaContrasena
    };

    try {
      const response = await patchPassword(payload);//
      toast.success(response.data.message ?? 'Contraseña actualizada correctamente');
      navigate('/perfil'); // Redirige al perfil después de actualizar
    } catch (error) {
      console.error('Error al actualizar contraseña:', error.response?.data);
      toast.error(error.response?.data?.error || 'Error al actualizar la contraseña.');
    }
  };

  return (
    <div className="content-wrapper">
      <h1>Cambiar Contraseña</h1>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="contrasena_actual">Contraseña Actual:</label>
            <input
              type="password"
              id="contrasena_actual"
              className="form-control"
              value={contrasenaActual}
              onChange={(e) => setContrasenaActual(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="nueva_contrasena">Nueva Contraseña:</label>
            <input
              type="password"
              id="nueva_contrasena"
              className="form-control"
              value={nuevaContrasena}
              onChange={(e) => setNuevaContrasena(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="repetir_contrasena">Repetir Nueva Contraseña:</label>
            <input
              type="password"
              id="repetir_contrasena"
              className="form-control"
              value={repetirContrasena}
              onChange={(e) => setRepetirContrasena(e.target.value)}
            />
          </div>

          <div className="form-group">
            <button type="submit" className="btn btn-create">Guardar Cambios</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
